import cdpActionsPlan from '@metrics/plan.json';
import * as factDefinitions from '@analytics/factDefinitions/index';
import type { FactDefinition } from './types';

type CdpAction = Record<string, unknown> & {
  name: string;
  destinations?: string[];
  metadata: {
    analytics: {
      id: string;
      name: string;
      objectIdAttribute?: string;
      activityType?: string;
      type: string;
      path?: string;
      ver?: string;
    };
  };
  rules: {
    properties: {
      properties: {
        properties: {
          [key: string]: unknown;
        };
      };
    };
  };
};

const convertCdpActionToFactDefinition = (cdpAction: CdpAction): FactDefinition => {
  const { destinations, metadata, rules } = cdpAction;
  const { id, name, activityType, objectIdAttribute, type, path, ver } = metadata?.analytics || {};
  const cdpPlanBasePropsSet = new Set(Object.keys(cdpActionsPlan.tracking_plan.baseProperties.properties));
  const attributes = Object.keys(rules.properties.properties.properties).filter(
    attribute => !cdpPlanBasePropsSet.has(attribute)
  );
  return {
    id,
    name,
    type,
    objectIdAttribute,
    path,
    ver,
    activityType,
    attributes,
    destinations
  };
};

const getFactDefinitions = (): FactDefinition[] => {
  const factDefinitionsArray = Object.values(factDefinitions);
  const factDefinitionsIds = new Set(factDefinitionsArray.map(fact => fact.id));
  const analyticsDestinationsSet = new Set(['Analytics', 'AttendeeActivities']);
  const destinationsIncludesAnalytics = (destinations: string[] | string) =>
    destinations === 'all' ||
    (Array.isArray(destinations) && destinations.some(destination => analyticsDestinationsSet.has(destination)));

  const factDefinitionsFromCdpActions = cdpActionsPlan.tracking_plan.rules.events
    .filter(
      event =>
        event?.metadata?.analytics?.id &&
        !factDefinitionsIds.has(event.metadata.analytics.id) &&
        destinationsIncludesAnalytics(event.destinations)
    )
    .map(event => convertCdpActionToFactDefinition(event as CdpAction));

  return [...factDefinitionsArray, ...factDefinitionsFromCdpActions];
};

const analyticsDefinitionsArray = getFactDefinitions();
export default analyticsDefinitionsArray;
